module.exports = __webpack_public_path__ + "img/copy.e89f7acb.webp";